
        var result = require("!!../../../../../node_modules/css-loader/index.js!./customer-reports-add.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/customers/customer-overview/dialogs/customer-reports-add.component.css
// module id = 2492
// module chunks = 1